// https://qiita.com/mimoe/items/855c112625d39b066c9a

export default {
    kanaToHira: function(str) {
        return str.replace(/[\u30a1-\u30f6]/g, function(match) {
            const chr = match.charCodeAt(0) - 0x60;
            return String.fromCharCode(chr);
        });
    },
    hiraToKana: function(str) {
        return str.replace(/[\u3041-\u3096]/g, function(match) {
            const chr = match.charCodeAt(0) + 0x60;
            return String.fromCharCode(chr);
        });
    }
}
